import { useCallback } from "react";

import { ISwap } from "../../../../api/swap";
import { useAlerting, useTranslation } from "../../../../hooks";
import { useZusDialogStore } from "../../../../zustand/store";

interface UseSwapProps {
  resetAmount: () => void;
  validateFields: () => boolean;
  swapApiFunc: (payload: ISwap) => Promise<any>;
  swapPayload?: ISwap;
}

export const useSwap = ({
  resetAmount,
  validateFields,
  swapApiFunc,
  swapPayload,
}: UseSwapProps) => {
  const { alerting } = useAlerting();
  const { t } = useTranslation("createSwapRequest");

  const zusDialog = useZusDialogStore();

  const handleSwap = useCallback(async () => {
    const isCanSwap = validateFields();

    if (!isCanSwap) {
      return;
    }

    if (!swapPayload) {
      return;
    }

    zusDialog.openExtra("loadingDialog");
    const res = await swapApiFunc(swapPayload);
    zusDialog.closeExtra();

    if (!res) {
      return;
    }

    alerting("success", t("swapSuccess"));
    resetAmount();
  }, [validateFields, swapPayload]);

  return {
    handleSwap,
  };
};
